var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-zoom-container",style:({ height: _vm.height, width: _vm.width }),on:{"mouseenter":_vm.handleMouseEnter,"mousemove":_vm.handleMouseMove,"mouseleave":_vm.handleMouseLeave}},[_c('img',{staticClass:"product-zoom-img",style:(_vm.zoomStyle),attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }